module.exports = __webpack_public_path__ + "static/media/s_32.1598977f.mp3";